<template>
  <el-form ref="form_tt" :model="form_tt" label-width="0px" @submit.native.prevent>
    <div class="side-search-form-box">
      <div class="side-search-form-title">ユーザー名/キーワード検索</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <div class="side-search-form-radio" v-show="activate > 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tt.radio" :label="1" @change="resetKeyword()">
            ユーザー名
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tt.radio" :label="2" @change="resetKeyword()">
            キーワード
            <el-tooltip placement="top" content="名前、プロフィール、投稿内容に含まれるキーワードで検索します。">
              <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
            </el-tooltip>
          </el-radio>
        </div>
        <div class="side-search-form-radio" v-show="activate < 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tt.radio" :label="1">ユーザー名</el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tt.radio" :label="2" disabled>キーワード</el-radio>
        </div>
        <sidemenuSuggestInfluencer 
          v-show="form_tt.radio == 1" 
          :name.sync="form_tt.account_name" 
          :sns_type="'tiktok'"
          @resultCount="resultCount()" 
          @nameSearch="nameSearch()"
        />
        <sidemenuSuggestKeyword 
          v-show="form_tt.radio == 2" 
          :keyword.sync="form_tt.keyword" 
          :sns_type="'tiktok'" 
          :exclude_keyword.sync="form_tt.exclude_keyword"
          @resultCount="resultCount()" 
          @search="search()"
        />
      </div>
    </div>

    <div class="side-search-form-box">
      <div class="side-search-form-title">他SNS登録</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <el-radio-group v-model="form_tt.other_sns_type" size="mini" style="margin: 12px 0 0;" @change="resultCount()">
          <el-radio :class="dark_mode ? 'dark' : ''" label="">
            -
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="instagram">
            <font-awesome-icon :icon="['fab', 'instagram']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="youtube">
            <font-awesome-icon :icon="['fab', 'youtube']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="twitter">
            <svg width="13" height="13" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                  fill="currentColor"/>
            </svg>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">性別</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio youtube" style="margin-bottom:0px">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tt.gender_female" @change="resultCount()">女性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tt.gender_male" @change="resultCount()">男性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tt.gender_group" @change="resultCount()">
              グループ
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tt.gender_other" @change="resultCount()"
                         class="bottom">
              その他
              <el-tooltip placement="top"
                          content="その他：ブランド、ショップ、キャラクター/ペットなどの非人物アカウントです">
                <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
              </el-tooltip>
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode"
                         v-model="form_tt.gender_null" @change="resultCount()" class="bottom"></el-checkbox>
          </div>
        </div>
      </div>
      <div class="side-search-form-title">フォロワー数</div>
      <el-form-item label class="slider">
        <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_tt.followers" @change="resultCount()" :step="5000"
                   name="follower" :marks="follower_marks" range :max="500000"></el-slider>
      </el-form-item>
      <div class="side-search-form-title">総いいね数</div>
      <el-form-item label class="slider">
        <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_tt.heartCount" @change="resultCount()" :step="100000"
                   name="viewRate" :marks="heart_marks" range :max="5000000"></el-slider>
      </el-form-item>
      <div class="side-search-form-title">EGR</div>
      <el-form-item label class="slider">
        <el-slider
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tt.average_engagement_rate"
            @change="resultCount()"
            :step="0.5"
            name="egr"
            :marks="average_engagement_rate_marks"
            range
            :max="10"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">フォロワー女性比率</div>
      <el-form-item label class="slider">
        <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_tt.female_ratio"
          @change="resultCount()"
          :step="5"
          name="gender"
          :marks="female_ratio_marks"
          range
          :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">SCORE</div>
      <el-form-item label class="slider" style="margin-bottom:10px">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tt.score"
            @change="resultCount()"
            :step="1"
            name="score"
            :marks="score_marks"
            range
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">視聴率中央値</div>
      <el-form-item label class="slider" style="margin-bottom:10px">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tt.median_playRate"
            name="median_playRate"
            @change="resultCount()"
            :step="10"
            :marks="viewRate_marks"
            range
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">視聴回数中央値</div>
      <el-form-item label class="slider" style="margin-bottom:10px">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tt.median_playCount"
            name="median_playCount"
            :marks="median_playCount_marks"
            @change="resultCount()"
            :step="1000"
            range
            :max="500000"
        ></el-slider>
      </el-form-item>
      <!-- PR率 -->
      <div class="side-search-form-title">PR率</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tt.pr_rate"
            @change="resultCount()"
            :step="1"
            name="pr_rate"
            :marks="pr_rate_marks"
            range
            :min="0"
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">
        <span class="pointer" @click="showDetailOption()"
        >詳細オプション
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px;"/>
        </span>
      </div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-bottom:10px"
           v-show="detail_option">
        <div class="side-search-form-title" style="color: #aaa; margin-top:5px">リストに含まれるインフルエンサーを除外
        </div>
        <el-form-item>
          <el-cascader
              v-model="form_tt.exclude_list"
              :options="sidemenu_option.mylist_tiktok"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="除外するリストを選択"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="small"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">認証バッジの有無</div>
        <el-form-item>
          <el-select
              clearable
              :class="dark_mode ? 'dark' : ''"
              class="sidemenu-input"
              v-model="form_tt.exclude_badge"
              @change="resultCount()"
              style="margin-left: 0px;"
              placeholder="認証バッジの有無"
              size="small"
          >
            <el-option label="認証バッジ付きのみを表示" value="only"></el-option>
            <el-option label="認証バッジ付きを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">お気に入りの有無</div>
        <el-form-item>
          <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="form_tt.exclude_favorite"
                     @change="resultCount()" style="margin-left: 0px;" placeholder="お気に入りの有無" size="small">
            <el-option label="お気に入りのみを表示" value="only"></el-option>
            <el-option label="お気に入りを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">カスタマイズタグ</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form_tt.tags_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form_tt.tags"
              :options="sidemenu_option.tag_list"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="カスタマイズタグを選択"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">Webリンク</div>
        <el-form-item class="bottom">
          <el-input
              v-model="form_tt.weblink"
              class="side-search-form-input"
              :class="dark_mode ? 'dark' : ''"
              placeholder="Webリンクに含まれるキーワード"
              size="mini"
              clearable
              @input="resultCount()"
          ></el-input>
        </el-form-item>
      </div>
    </div>

    <div class="side-search-form-button" :class="dark_mode ? 'dark' : ''">
      <el-button size="small" @click="resetParams()" style="margin-right:10px;" :type="dark_mode ? 'info' : 'default'"
                 :class="dark_mode ? 'dark' : ''">リセット
      </el-button>
      <div style="display:flex; flex:1">
        <el-button native-type="submit" type="primary" class="sidemenu-load" :class="dark_mode ? 'dark' : ''"
                   @click="search()" style="width:100%" :disabled="result_loading" size="small">
          <div class="flex-row">
            検索
            <div class="loader--mini" v-if="result_loading"></div>
          </div>
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
const root = process.env.VUE_APP_API;
const resultCountAPI = root + "/api/search/result_count_tiktok";
import sidemenuSuggestInfluencer from "./sidemenu_suggest_influencer";
import sidemenuSuggestKeyword from "./sidemenu_suggest_keyword";
import { runCampaignGate } from '@/utils/campaignGate';

export default {
  name: "sidemenuTiktok",
  components: {
    sidemenuSuggestInfluencer,
    sidemenuSuggestKeyword,
  },
  data() {
    return {
      initialForm: null,
      result_count: "",
      follower_marks: {
        500000: "500K+",
      },
      heart_marks: {
        5000000: "5M+",
      },
      female_ratio_marks: {
        100: "100%",
      },
      average_engagement_rate_marks: {
        10: "10%+",
      },
      score_marks: {
        100: "100",
      },
      viewRate_marks: {
        100: "100%+",
      },
      median_playCount_marks: {
        500000: "500K+",
      },
      pr_rate_marks: {
        100: "100%",
      },
      mylist_tiktok: [],
      actionId: +new Date(),
      requestId: +new Date(),
      result_loading: false,
      next_cursor: "",
      language: "jp",
      noindex: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_tt() {
      return this.$store.state.form_tt;
    },
    form_tt_initial() {
      return this.$store.state.form_tt_initial;
    },
    tt_search() {
      return this.$store.state.tt_search;
    },
    sidemenu_option() {
      return this.$store.state.sidemenu_option;
    },
    detail_option() {
      return this.$store.state.detail_option;
    },
  },
  mounted() {
  },
  created() {
    if (!Array.isArray(this.form_tt.pr_rate) || this.form_tt.pr_rate.length !== 2) {
      this.$set(this.form_tt, 'pr_rate', [0, 100]);
    }
  },
  methods: {
    resultCount() {
      this.noindex = false;
      this.result_loading = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      const form_tt = Object.assign({}, this.form_tt);
      form_tt.has_recent_post_1month = !!this.$store.state.recent_post_1month;
      params.append("params", JSON.stringify(form_tt));
      this.axios
          .post(resultCountAPI, params, {requestId: this.requestId})
          .then((response) => {
            this.result_loading = false;
            this.result_count = response.data.result_count;
            this.noindex = response.data.noindex;
            this.$store.dispatch("form_tt", form_tt);
          })
          .catch(() => {
            this.result_loading = false;
            this.result_count = 0;
          });
    },
    async search() {
      var form_tt = Object.assign({}, this.form_tt);
      form_tt.has_recent_post_1month = !!this.$store.state.recent_post_1month;

      // 記号は「._()@#&･」及び全角のみ許可
      var reg = new RegExp(/[!"$%'*+,/:;<=>?@[\\\]^`{|}~]/g);
      // ローマ字1文字（大文字・小文字）だけの入力をNG
      var singleAlphaReg = new RegExp(/^[A-Za-z]$/);

      if (reg.test(form_tt.account_name) || 
        reg.test(form_tt.keyword) ||
        reg.test(form_tt.exclude_keyword) ||
        singleAlphaReg.test(form_tt.account_name) ||
        singleAlphaReg.test(form_tt.keyword) ||
        singleAlphaReg.test(form_tt.exclude_keyword)
    ) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "検索キーワードが短すぎる、もしくは使用できない記号が含まれています",
        });
        return;
      }

      // キャンペーンモーダルを表示（閉じたら続行）
      try {
        await runCampaignGate('partner_introduce');
      } catch (e) {/* no-op: モーダル取得に失敗しても検索は続行 */}

      this.$store.dispatch("tt_search", form_tt);
      this.$router.push({
        name: "tiktoker",
        query: {actionId: (this.actionId += 1)},
        params: {sns_type: "tiktok"},
      });
    },
    nameSearch() {
      const account_name = this.form_tt.account_name;
      var form_tt = Object.assign({}, this.form_tt_initial);
      form_tt.account_name = account_name;
      this.$store.dispatch("form_tt", form_tt);
      this.resultCount();
      this.search();
    },
    resetParams() {
      this.$store.dispatch("recent_post_1month", false);
      this.$store.dispatch("form_tt", Object.assign({}, this.form_tt_initial)).then(() => {
        this.resetKeyword();
        this.resultCount();
      });
    },
    resetKeyword() {
      this.form_tt.account_name = "";
      this.form_tt.keyword = "";
      this.form_tt.exclude_keyword = "";
      this.resultCount();
    },
    showDetailOption() {
      this.$store.dispatch("showDetailOption");
    },
    created: function () {
      if (this.$store.state.form_tt) {
        this.initialForm = JSON.parse(this.$store.state.form_tt_initial);
      } else {
        console.error("form_tt is undefined");
      }
    }
  },
};
</script>
